import Link from "next/link";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IProduct } from "../../model/product";
import styles from "./product-small-tile.module.css";
export default function ProductSmallTile(props: {
  product: IProduct;
  size: "normal" | "xs";
  detailsPath: string;
}) {
  return (
    <Link
      className={styles.container}
      href={`${props.detailsPath?.toLowerCase()}/${props.product.urlName}`}
    >
      <article className={styles.card}>
        <div className={styles.imageArea}>
          <LazyLoadImage
            className={styles.image}
            src={props.product.image}
            alt={props.product.name}
          />
        </div>
        <div className={styles.content}>
          <span className={styles.brand}>{props.product.brand}</span>
          <h3>{props.product.name}</h3>
          <div className={styles.priceRow}>
            <div>
              <span className={styles.priceLabel}>Fra</span>
              <strong>
                {props.product?.price?.toLocaleString("no-NO", {
                  style: "currency",
                  currency: "NOK",
                  trailingZeroDisplay: "stripIfInteger",
                })}
              </strong>
            </div>
            <span className={styles.cardAction}>Sammenlign <span aria-hidden="true">&rarr;</span></span>
          </div>
        </div>
      </article>
    </Link>
  );
}
